// extracted by mini-css-extract-plugin
export var aboveInput = "_i7-0";
export var actionButton = "_i7-5";
export var actionButtonContainer = "_i7-1";
export var actionIcon = "_i7-6";
export var aiInfoContainer = "_i7-2";
export var attachmentWrapper = "_i7-7";
export var bold = "_i7-3";
export var checkIcon = "_i7-8";
export var clickingRecipientBar = "_i7-11";
export var commentThreadSwitch = "_i7-a";
export var draftImage = "_i7-b";
export var draftImageContainer = "_i7-c";
export var draftImages = "_i7-e";
export var editButton = "_i7-g";
export var editor = "_i7-f";
export var editorContainer = "_i7-y";
export var editorErrorTooltipWrapper = "_i7-9";
export var headerDivider = "_i7-h";
export var icon = "_i7-i";
export var info = "_i7-j";
export var internal = "_i7-n";
export var internalDivider = "_i7-k";
export var internalMessage = "_i7-l";
export var messageInputCard = "_i7-m";
export var messageInputForm = "_i7-o";
export var messageInputFormInternal = "_i7-p";
export var options = "_i7-q";
export var publicMessageCustomer = "_i7-s";
export var publicMessageMerchant = "_i7-r";
export var removeImageButton = "_i7-d";
export var replyButtons = "_i7-t";
export var showSignatureButton = "_i7-u";
export var spinner = "_i7-v";
export var verticalButtonDivider = "_i7-4";
export var visibilitySelector = "_i7-w";
export var warning = "_i7-x";
export var wrappingText = "_i7-z";
export var writingInternalNoteTopBorder = "_i7-10";